import React from 'react'
import {Badge, ImageBuffer, SubHeader} from '../../'
import { servicesData } from '../../../utils/constants'

import './services.css'

const Services = () => {
  return (
    <>
        <div id="services" className='services-wrapper'>
            <Badge title="Our Services" />
            <SubHeader title="" description="we are committed to providing high-quality, compassionate home health care." />
            <div className="services-container">
                <div className="services-gradient-background"></div>
                <div className='services-box-container'>
                    {servicesData.map((result, index) => {

                    return(
                        <div key={index} className="services-box">
                            <div className="services-box-main-cover">
                                <div className="services-box-image">
                                    <ImageBuffer src={result.icon} alt={result?.title} />
                                </div>
                            </div>

                            <p className="services-title">{result?.title}</p>
                            <div className="services-box-description">
                                {result?.description}
                            </div>
                        </div>
                    )  
                    })}
                </div>
            </div>
        </div>
    </>
  )
}

export default Services